// Regras de graus maçônicos — hierarquia clássica.
// Um Irmão de grau superior PODE participar de sessão de grau inferior,
// mas o contrário não é permitido. Além disso, o grau é determinado pelas
// datas ritualísticas em relação à DATA DA SESSÃO (não à data atual):
// um Irmão iniciado APÓS a sessão não pode aparecer nela.

// Ordem crescente de graus simbólicos
const DEGREE_RANK = {
  "1 - Aprendiz": 1,
  "2 - Companheiro": 2,
  "3 - Mestre": 3,
  "Mestre Instalado": 4,
};

/**
 * Retorna o rank numérico do grau (0 se desconhecido).
 */
export const degreeRank = (degree) => DEGREE_RANK[degree] || 0;

/**
 * Retorna o grau efetivo do Irmão na data-referência (YYYY-MM-DD).
 * Se refDate não for informado, usa o grau atual do documento (comportamento antigo).
 * Retorna null se o Irmão ainda não havia sido iniciado nessa data.
 */
export const memberDegreeAtDate = (member, refDate) => {
  if (!member) return null;
  if (!refDate) return member.degree || null;
  const D = String(refDate).slice(0, 10);
  const on = (val) => val && String(val).slice(0, 10) <= D;
  if (on(member.installation_date)) return "Mestre Instalado";
  if (on(member.exaltation_date)) return "3 - Mestre";
  if (on(member.elevation_date)) return "2 - Companheiro";
  if (on(member.initiation_date)) return "1 - Aprendiz";
  return null; // ainda não iniciado nessa data
};

/**
 * Verifica se um Irmão do `memberDegree` pode participar de uma sessão
 * cujo grau exigido mínimo é `sessionDegree`.
 * Regra: grau do membro >= grau da sessão.
 */
export const canAttendSession = (memberDegree, sessionDegree) => {
  const mr = degreeRank(memberDegree);
  const sr = degreeRank(sessionDegree);
  if (!sr) return true; // sessão sem grau definido — permissivo
  if (!mr) return false; // membro sem grau (ex.: ainda não iniciado) — bloqueia
  return mr >= sr;
};

/**
 * Filtra a lista de Irmãos elegíveis para uma sessão.
 * - Se `sessionDate` for informada, considera o grau que o Irmão POSSUÍA naquela data
 *   (exclui Irmãos iniciados após a sessão e trata elevação/exaltação retroativamente).
 * - Se apenas `sessionDegree` for informado, usa o grau atual (comportamento antigo).
 */
export const filterMembersForSession = (members, sessionDegree, sessionDate) => {
  if (!sessionDegree && !sessionDate) return members;
  return (members || []).filter((m) => {
    const degOnDate = sessionDate ? memberDegreeAtDate(m, sessionDate) : (m.degree || null);
    return canAttendSession(degOnDate, sessionDegree);
  });
};
